import actionTypes from 'constants/actionTypes';
import Immutable from 'immutable';

const setInitialState = () => {
    return Immutable.Map().merge({
        showStandByJointHolderView: false,
    });
};

const initialState = setInitialState();

const standByReducer = (state, action) => {
    state = state || initialState;

    if (action.type === actionTypes.SET_STANDBY_JOINT_HOLDERS) {
        return state.merge({
            showStandByJointHolderView: action.showStandByJointHolderView,
        });
    }

    return state;
};

module.exports = standByReducer;
